export function addItemToSet<T>(set: Set<T> | undefined | null, item: T): Set<T> {
  if (!set) {
    return new Set([item]);
  }

  return new Set(set).add(item);
}

export function removeItemFromSet<T>(set: Set<T> | undefined | null, item: T): Set<T> {
  if (!set) {
    return new Set();
  }

  const result = new Set(set);
  result.delete(item);
  return result;
}

export function addItemToMap<K, V>(map: Map<K, V> | undefined | null, key: K, value: V): Map<K, V> {
  if (!map) {
    return new Map([[key, value]]);
  }

  return new Map(map).set(key, value);
}

export function removeItemFromMap<K, V>(map: Map<K, V> | undefined | null, key: K): Map<K, V> {
  if (!map) {
    return new Map();
  }

  const result = new Map(map);
  result.delete(key);
  return result;
}

export function addItemToArray<T>(
  array: T[] | undefined | null,
  item: T,
  p?: { position: "front" | "back" }
): T[] {
  if (!array) {
    return [item];
  }

  if (p?.position === "front") {
    return [item, ...array];
  }

  return [...array, item];
}

export function removeItemFromArray<T>(
  array: T[] | undefined | null,
  item: T,
  eqFn?: (a: T, b: T) => boolean
): T[] {
  if (!array) {
    return [];
  }

  return array.filter((i) => (eqFn ? !eqFn(i, item) : i !== item));
}

export function updateItemAtIndex<T>(array: T[], idx: number, item: T): T[] {
  return array.map((i, iIdx) => (iIdx === idx ? item : i));
}
